// import * as types from '@/store/mutation-types'

import { isNumber } from 'lodash'

// TODO: comments, cleanup

// state
const limitsModel = {
  max_medias: false,
  max_domains: false,
  // max_queries: false,
  max_boards: false,
  max_embeds: false,
  max_feeds: false,
  max_campaigns: false,
  max_influencers: false,
  max_monthly_influencers: false,
  max_active_campaigns: false,
  max_hashtags_tracked: false,
  max_competitors_tracked: false,
}

export const state = {
  ...limitsModel,
}

// getters
export const getters = {
  get_limits: (state) => (key) => {
    if (typeof state[key] !== 'undefined') {
      return state[key]
    }
    return false
  },

  validate_limit: (state) => (key, count) => {
    if (typeof state[key] !== 'number') {
      return true
    } else {
      return (state[key] && state[key] > count) || false
    }
  },
}

// mutations
export const mutations = {
  INIT(state, data) {
    // counts with limit
    state.max_medias = isNumber(data.max_medias) ? data.max_medias : false
    state.max_domains = isNumber(data.max_domains) ? data.max_domains : false
    // state.max_queries = isNumber(data.max_queries) ? data.max_queries : false
    state.max_boards = isNumber(data.max_boards) ? data.max_boards : false
    state.max_embeds = isNumber(data.max_embeds) ? data.max_embeds : false
    state.max_feeds = isNumber(data.max_feeds) ? data.max_feeds : false
    state.max_campaigns = isNumber(data.max_campaigns) ? data.max_campaigns : false
    state.max_influencers = isNumber(data.max_influencers) ? data.max_influencers : false
    state.max_monthly_influencers = isNumber(data.max_monthly_influencers) ? data.max_monthly_influencers : false
    state.max_active_campaigns = isNumber(data.max_active_campaigns) ? data.max_active_campaigns : false
    state.max_hashtags_tracked = isNumber(data.max_hashtags_tracked) ? data.max_hashtags_tracked : false
    state.max_competitors_tracked = isNumber(data.max_competitors_tracked) ? data.max_competitors_tracked : false
  },

  INCREMENT_COUNT(state, { type, value = 1 }) {
    state[type].count += value
  },

  DECREMENT_COUNT(state, { type, value = 1 }) {
    state[type].count -= value
  },

  RESET(state) {
    Object.keys(state).forEach((key) => {
      state[key] = limitsModel[key]
    })
  },
}

// actions
export const actions = {}
